import React, { useRef, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import ContextModal, { ContextModalWidth } from '../context-modal';
import OutsideClickHandler from '../../helpers/hoc/close/outside-click-handler';
import { ListItem, ListItemContainer, CheckboxWrapper, ReviewIcon, ContextWrapper, StudentProgress } from './styled';
import SvgIcon from '../svg-icon/svg-icon';
import { Book, ResultsBar } from '../../helpers/icon-dictionary';
import Checkbox from '../checkbox';
import {
  MAX_STUDENT_NAME_LENGTH,
  getContextCoords,
  getTeacherAuthToken
} from '../../helpers/utils';
import { UNCHECKED, CHECKED } from '../checkbox/constants';
import { getLocale } from '../../helpers/locale';

const StudentListItem = (props) => {
  const [showContextMenu, setContextMenu] = useState(false);
  const [positionX, setPositionX] = useState(0);
  const [positionY, setPositionY] = useState(0);
  const [positionArrow, setPositionArrow] = useState(0);
  const liRef = useRef(null);
  const { student, checkboxHandler, showCheckbox, i18n } = props;
  let fullName = `${student.lastName}, ${student.firstName}`;
  const { selectedStudentIds } = useSelector(state => state.UPFAssignReducer);
  let fullNameTitle;

  if (fullName.length > MAX_STUDENT_NAME_LENGTH) {
    fullNameTitle = fullName;
    fullName = `${fullName.substr(0, MAX_STUDENT_NAME_LENGTH)}...`;
  }

  const handleOnClick = (cbStatus) => {
    checkboxHandler(student && student.id, cbStatus);
  };

  const showContextModal = () => {
    const ContextModalPos = 'right';
    const { posX, posY, posArrow } = getContextCoords(liRef.current.getBoundingClientRect(),
      ContextModalWidth, ContextModalPos);
    setPositionY(posY);
    setPositionX(posX);
    setPositionArrow(posArrow);
    setContextMenu(!showContextMenu);
  };

  const reviewHandler = (id) => {
    const assessmentUrl = window._env_.AssessmentMLEBaseUrl;
    const token = getTeacherAuthToken();
    const locale = getLocale();
    const Url = `${assessmentUrl}?authToken=${token}&assignmentId=${id}&locale=${locale}&isReview=true&newContent=true`;
    window.open(Url, '_blank');
  };

  const { id = '', showProgress, assignmentId, isReviewed, studentPct } = student;

  return (
    <ListItemContainer key={`_${id}_`} data-name="student-list">
      {showProgress ? (
        <Fragment>
          <ListItem showCheckbox={showCheckbox} onClick={showContextModal} ref={liRef} showProgress>
            <span className="fullName" title={fullNameTitle}>{fullName}</span>
            <StudentProgress
              percent={studentPct}
              showDot={!isReviewed}
            >
              <SvgIcon icon={Book} />
            </StudentProgress>
          </ListItem>
          <OutsideClickHandler callback={() => setContextMenu(false)} forButton={`showContextModal_${id}`}>
            <ContextModal
              show={showContextMenu}
              positionArrow={positionArrow}
              positionX={positionX}
              positionY={positionY}
              customStyle={'cursor: pointer;'}
              contextPos="right">
              <ContextWrapper role="button" tabIndex="-1" onClick={() => reviewHandler(assignmentId)}>
                <ReviewIcon><SvgIcon icon={ResultsBar} /></ReviewIcon> {i18n.t`Review Assessment`}
              </ContextWrapper>
            </ContextModal>
          </OutsideClickHandler>
        </Fragment>
      ) : (<ListItem showCheckbox={showCheckbox} ref={liRef}>
        <span className="fullName" title={fullNameTitle}>{fullName}</span>
      </ListItem>)
      }
      <CheckboxWrapper>
        {showCheckbox === true && (<Checkbox
          checkboxHandler={cbStatus => handleOnClick(cbStatus)}
          state={selectedStudentIds.includes(id) ? CHECKED : UNCHECKED} />)}
      </CheckboxWrapper>
    </ListItemContainer>
  );
};

StudentListItem.defaultProps = {
  showCheckbox: true
};

StudentListItem.propTypes = {
  student: PropTypes.object,
  checkboxHandler: PropTypes.func,
  showCheckbox: PropTypes.bool,
  i18n: PropTypes.object
};

export default StudentListItem;
